export default __webpack_public_path__ + "static/1595-98f328af1f5a74e1730f4d3cb7395f93.gif";